<template>
  <div>
    <div class="line"></div>
    <div class="content">
      <h4>物种共线性分析</h4>
      <p>两个物种中，同源基因在基因座位上的连锁及顺序保守性称为基因组共线性，共线性分析为近缘物种之间重要基因的研究提供了便利。共线性分析可以揭示基因组及近缘物种基因组的染色体结构上的异同，寻找易位、倒位、插入缺失等染色体结构变异区。对目标物种进行共线性分析，可以比较相关物种的基因组结构、推导最先物种的演化历史、指导重要已知性状基因的定位与克隆。</p>
      <img src="../../assets/u260.png" />
      <p class="fontcenter">共线性分析作图示例</p>

      <h4 class="mgtop">代谢通路挖掘</h4>
      <p>根据KEGG pathway代谢通路数据库注释，进行针对特定物质的代谢通路关键基因的blast序列比对和数据库比对，挖掘代谢通路中关键调控候选基因及可能存在的基因簇。结合转录组和代谢组数据，进行共表达分析，预测代谢物质合成通路。</p>
      <img src="../../assets/u263.png" />
      <p class="fontcenter">代谢通路挖掘图示例</p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.line{
    width: 100%;
    height: 5px;
    background: #eee;
}
.content {
  width: 1100px;
  height: auto;
  margin: 0 auto;
  padding: 0 50px;
  border: 1px solid #eeee;
  text-align: center;
}
.content p{
    line-height: 30px;
    font-size: 14px;
    text-align: left;
}
.content h4{
    text-align: left;
}
.content p.fontcenter{
    text-align: center;
}
.content .mgtop{
    margin-top: 50px;
}
</style>